<template>
  <div class="map-style line">
    <classes-color-picker
      @change-property="changeProperty"
      @change-classes="changeClasses"
      @change-strings="changeStrings"
      :id="id"
      :layer-style="layerStyle.style"
      :layer-controller="layerController"
      property="line"
      title="Цвет"
    />
    <classes-slider-picker
      @change-property="changeProperty"
      @change-range="changeRange"
      :id="id"
      :layer-style="layerStyle.style"
      :layer-controller="layerController"
      property="line-width"
      title="Толщина"
    />
    <popup-fields-picker
      :id="id"
      :layer-style="layerStyle"
      :layer-controller="layerController"
      title="Информация"
    />
    <dashed
      style="margin-top: 8px;"
      :config="layerStyle.dashed"
      @toggle="toggleLineProperty('dashed', $event)"
    />
    <arrows
      :config="layerStyle.arrows"
      @toggle="toggleLineProperty('arrows', $event)"
    />
  </div>
</template>

<script>
import ClassesColorPicker from "../input-sources/classes-color-picker";
import ClassesSliderPicker from "../input-sources/classes-slider-picker";
import PopupFieldsPicker from "../input-sources/popup-fields-picker";
import Arrows from "../arrows/arrows";
import Dashed from "../dashed/dashed";

export default {
  props: ["id", "layer-style", "layer-controller"],
  components: {
    ClassesColorPicker,
    ClassesSliderPicker,
    PopupFieldsPicker,
    Arrows,
    Dashed
  },
  methods: {
    changeProperty(payload) {
      this.$emit("change-property", payload);
    },
    changeClasses(payload) {
      this.$emit("change-classes", payload);
    },
    changeStrings(payload) {
      this.$emit("change-strings", payload);
    },
    changeRange(payload) {
      this.$emit("change-range", payload);
    },
    toggleLineProperty(type, value) {
      this.layerStyle[type].enabled = value;
      this.$emit("toggle-line-property", type);
    }
  },
  created() {
    if (!this.layerStyle.arrows) {
      this.$set(this.layerStyle, "arrows", { enabled: false });
    }
    if (!this.layerStyle.dashed) {
      this.$set(this.layerStyle, "dashed", { enabled: false });
    }
  }
};
</script>

<style lang="scss"></style>
